import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { User } from "@lhd/types";

type InitialState = {
  loggedInUser: boolean;
  user: null | User;
};

const initialState: InitialState = {
  loggedInUser: false,
  user: null,
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    loginSuccess(state) {
      state.loggedInUser = true;
    },
    userLogin(state, action: PayloadAction<{ user: User }>) {
      state.user = action.payload.user;
    },
    userLogout(state) {
      state.user = null;
      state.loggedInUser = false;
    },
    updateListCompanies(
      state,
      action: PayloadAction<{ companies: User["companies"] }>,
    ) {
      if (state.user?.companies) {
        state.user.companies = action.payload.companies;
      }
    },
  },
});

export const { userLogin, userLogout, loginSuccess, updateListCompanies } =
  usersSlice.actions;

export default usersSlice;
